import React from 'react';

interface ChatIconProps {
  color?: string;
  fillcolor?: string;
  height?: number | string;
  width?: number | string;
}

/**
 * Chat icon SVG component
 *
 * @param color - Background color of the chat bubble (defaults to '#007AFF')
 * @param fillcolor - Color for the chat dots
 * @param height - Height of the icon (defaults to 64)
 * @param width - Width of the icon (defaults to 64)
 */
const ChatIcon: React.FC<ChatIconProps> = ({
  color = '#007AFF',
  fillcolor,
  height,
  width,
}) => (
  <svg
    width={width || 64}
    height={height || 64}
    viewBox='0 0 64 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8 10C8 6.686 10.686 4 14 4H50C53.314 4 56 6.686 56 10V38C56 41.314 53.314 44 50 44H19.172L8 55.172V10Z'
      fill={color}
    />
    <circle cx={22} cy={24} r={2.5} fill={fillcolor} />
    <circle cx={32} cy={24} r={2.5} fill={fillcolor} />
    <circle cx={42} cy={24} r={2.5} fill={fillcolor} />
  </svg>
);

export default ChatIcon;
